import { Routes } from '@angular/router';
import { InterviewDetailsResolver } from './modules/interview/interview-details/interview-details.resolver';


export const routes: Routes = [

      {
        path: '',
        loadChildren: () => import('./modules/home/home.route').then(m => m.default),
      },
      {
        path: 'interviews',
        loadChildren: () => import('./modules/interview/interview.route').then(m => m.default),
      },
      {
        path: 'about-us',
        loadChildren: () => import('./modules/about-us/about-us.route').then(m => m.default),
      },
      {
        path: 'youtube-channel',
        loadChildren: () => import('./modules/youtube-channel/youtube-channel.route').then(m => m.default),
      },
                {
            path: 'recommend-an-interview',
            loadChildren: () => import('./modules/contact-us/contact-us.route').then(m => m.default),
          },
      {
        path: 'search',
        loadComponent: () => import('./modules/search-results/search-results.component').then(c => c.SearchResultsComponent),

      },
      {
        path: 'coming-soon',
        loadComponent: () => import('./shared/coming-soon/coming-soon.component').then(c => c.ComingSoonComponent),
      },
      {
        path: 'terms',
        loadComponent: () => import('./modules/terms-service/terms-service').then(c => c.TermsService)
      },
      {
        path: 'privacy',
        loadComponent: () => import('./modules/privacy-policy/privacy-policy').then(c => c.PrivacyPolicy)
      },
      {
        path: 'robots.txt',
        redirectTo: '/robots.txt',
        pathMatch: 'full'
      },
      {
        path: ':slug',
        loadComponent: () => import('./modules/interview/interview-details/interview-details').then(c => c.InterviewDetails),
        resolve: {
          post: InterviewDetailsResolver
        }
      }

];
